import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export default function CustomTooltip(props) {
	const renderTooltip = (refs) => (
		<Tooltip className="grow-tooltip" id="button-tooltip" {...refs}>
			<div style={props.bold ? { fontWeight: "bold" } : {}}>
				{props.message && (
					props.message
				)}
				{props.paragraphs && (
					props.paragraphs.map((paragraph, index) => (
						<p className="f14" key={index}>{paragraph}</p>
					))
				)}
			</div>
		</Tooltip>
	);

	return (
		<div className={props.inline ? "d-inline-block" : "d-block"}>
			<OverlayTrigger style={props.style} delay={props.delay ? { show: 200, hide: props.delay } : { show: 200, hide: 200 }} overlay={renderTooltip}>
				{props.img ? (
					<i className={props.faClass}>{props.img}{props.label}</i>
				) : (
					<i className={props.faClass}>{props.label}</i>
				)}
			</OverlayTrigger>
		</div>
	);
}
